import { Route } from '@angular/router';
import { LandingPageComponent } from '@aa/angular/marketing';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    component: LandingPageComponent,
  },
];
